/**
 * @file paddlejs online
 * @author wanzhongyun
 */

 import { useState } from 'react';
 import { CheckboxValueType } from 'antd/lib/checkbox/Group';

 import { IPaddleJsOnlineListItem } from './../../type';

const useJSOnlineHooks = (typeList: IPaddleJsOnlineListItem[]) => {
    const [onlineStatus, setOnlineStatus] = useState<boolean>(false);
    const [switchStatus, setSwitchStatus] = useState<boolean>(false);
    const [currentImage, setCurrentImage] = useState<string>('');
    const [checkboxValue, setCheckboxValue] = useState<CheckboxValueType[]>([]);
    const [modelStatus, setModelStatus] = useState<boolean>(true);

    const switchOnchange = (cheked: boolean) => {
        setSwitchStatus(cheked);
    }

    const handleCheckboxChange = (value: CheckboxValueType[]) => {
        if (!value.length) {
            return;
        }
        const radioValue = value.filter((item) => !checkboxValue.includes(item as string));
        setCurrentImage(radioValue[0] as string);
        setCheckboxValue(radioValue);
    }

    const handlePhotoControlOpen = () => {
        setOnlineStatus(true);
        setModelStatus(true);
    };

    const handlePhotoControlClose = async() => {
        setTimeout(() => {
            setSwitchStatus(false);
            setCurrentImage(typeList[0]?.imageUrl ?? '');
            setCheckboxValue([typeList[0]?.imageUrl]);
            setOnlineStatus(false);
        }, 500);
    };

    return {
        onlineStatus,
        switchStatus,
        currentImage,
        modelStatus,
        checkboxValue,
        setOnlineStatus,
        setCurrentImage,
        setCheckboxValue,
        setModelStatus,
        switchOnchange,
        handleCheckboxChange,
        handlePhotoControlOpen,
        handlePhotoControlClose
    }
};



export default useJSOnlineHooks;